<template>
  <p class="caption grey--text" :class="{ 'caption--combobox': forCombobox }">
    <span class="d-block">{{ this.label }}</span>
  </p>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    forCombobox: Boolean
  }
}
</script>

<style lang="stylus" scoped>
.caption {
  margin-top: -10px;
}

.caption--combobox {
  margin-top: -26px;
}
</style>
